module.exports = __webpack_public_path__ + "img/pt2020-01.318c7242.svg";